export default __webpack_public_path__ + "static/media/icon-user.abd84f71.svg";